// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__4zmlP","contact_text":"Contact_contact_text__V1jeL","form":"Contact_form__Hp1Bg"};